module.exports = __webpack_public_path__ + "static/media/oklahomaYouthSuicidePrevention.fdc70885.jpg";